module.exports = __webpack_public_path__ + "img/Decoration_bapteme.1bdafc4.jpg";